export default __webpack_public_path__ + "static/media/buttonUnderImage.2f12b94f.webp";